var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopBrandTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 93,
    viewBox: "0 0 12 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.900879H0V92.9009H12V0.900879Z",
    fill: "#F16D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBrandTitle);
export default __webpack_public_path__ + "static/media/top_brand_title.9252631213bca10d2fc0c4afb63bbc78.svg";
export { ForwardRef as ReactComponent };